import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'propertyRef',
  type: 'object',
  title: 'Insert a property',
  fields: [
    defineField({
      title: 'Choose a property',
      name: 'property',
      type: 'string',
      options: {
        list: [
          { title: 'Fitment type', value: 'fitmentType' },
          { title: 'Tire size', value: 'tireSize' },
        ],
      },
    }),
  ],
  preview: {
    select: {
      title: 'property',
    },
  },
})
